/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  isFetching: false,
  isSending: false,
  deployment: { id: 0 },
  deployments: [],
  current: {}
};

const addWorkPackageToDeployment = (
  deployments = [],
  deploymentId = 0,
  workPackage = {}
) => {
  const newDeployment = deployments.find(d => d.id === deploymentId);
  newDeployment.results.push(workPackage);
  return deployments.map(d => {
    if (d.id === newDeployment.id) {
      return newDeployment;
    }
    return d;
  });
};

const removeWorkPackageFromDeployment = (
  deployments = [],
  deploymentId = 0,
  workPackage = {}
) => {
  const newDeployment = deployments.find(d => d.id === deploymentId);
  newDeployment.results = newDeployment.results.filter(
    r => r.id !== workPackage.id
  );
  return deployments.map(d => {
    if (d.id === newDeployment.id) {
      return newDeployment;
    }
    return d;
  });
};

const deploymentReducer = (state = initialState, action) => {
  const { deployments } = state;
  switch (action.type) {
    case Types.REQUEST_DEPLOYMENT:
      return Object.assign({}, state, {
        isFetching: true
      });
    case Types.REQUEST_DEPLOYMENT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isSending: false
      });
    case Types.RECEIVE_DEPLOYMENTS:
      return Object.assign({}, state, {
        isFetching: false,
        isSending: false,
        deployments: action.deployments,
        current: action.deployments.find(d => !d.shipped) || {}
      });
    case Types.SET_DEPLOYMENT:
      return Object.assign({}, state, {
        isFetching: false,
        nodeployment: false,
        deployment: action.deployment
      });
    case Types.SEND_DEPLOYMENT:
      return { ...state, isSending: true };
    case Types.ADD_WORK_PACKAGE_TO_DEPLOYMENT:
      return {
        ...state,
        isSending: false,
        deployments: addWorkPackageToDeployment(
          deployments,
          action.deploymentId,
          action.workPackage
        )
      };
    case Types.REMOVE_WORK_PACKAGE_FROM_DEPLOYMENT:
      return {
        ...state,
        isSending: false,
        deployments: removeWorkPackageFromDeployment(
          deployments,
          action.deploymentId,
          action.workPackage
        )
      };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false }
    default:
      return state;
  }
};

export default deploymentReducer;
